// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__GznQ7","title":"style_title__F+JW+","bottom":"style_bottom__kwS5e","label":"style_label__zzyx4"};